/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type IrrSddcProviderEnum = 'UNKNOWN_PROVIDER' | 'VMC' | 'VMC_STG' | 'GCVE' | 'EVS';

export const IrrSddcProviderEnum = {

    UNKNOWN_PROVIDER: 'UNKNOWN_PROVIDER' as IrrSddcProviderEnum,

    VMC: 'VMC' as IrrSddcProviderEnum,

    VMC_STG: 'VMC_STG' as IrrSddcProviderEnum,

    GCVE: 'GCVE' as IrrSddcProviderEnum,

    EVS: 'EVS' as IrrSddcProviderEnum
};

